<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card my-3">
                <div class="card-body">
                    <div class="card-header white text-green">Pending Loan approvals</div><br>
                        <div class="form-row" style="overflow-x:auto;">
                            <table id="example2" class="table table-bordered table-hover data-tables"
                                    data-options='{ "paging": false; "searching":false}'>
                                <thead>
                                    <tr>
                                        <th>S/N</th>
                                        <th>Username</th>
                                        <th>Amount</th>
                                        <th>Level</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr> 
                                </thead>
                                <tbody>
                                    <tr v-if="loading">
                                        <td colspan="10">
                                            <b-card>
                                                <b-skeleton animation="throb" width="85%"></b-skeleton>
                                                <b-skeleton animation="throb" width="55%"></b-skeleton>
                                                <b-skeleton animation="throb" width="70%"></b-skeleton>
                                            </b-card>
                                        </td>
                                    </tr>
                                    <template v-else>
                                        <tr v-if="pendingLoanRequestApprovals.length < 1">
                                            <td colspan="5">
                                                <p class="alert alert-info text-center">
                                                    There are no pending loan approvals
                                                </p>
                                            </td>
                                        </tr>
                                        <tr v-else v-for="reg,i in pendingLoanRequestApprovals" :key="i">
                                            <th scope="row">{{++i}}</th>
                                            <td>{{reg.user.username}}</td>
                                            <td>{{reg.loan_amount}}</td>
                                            <td>{{reg.level_id}}</td>
                                            <td>{{reg.created_at}}</td>
                                            <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-success  dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <i class="caret"></i>
                                                    </button>
                                                    <div class="dropdown-menu " aria-labelledby="dropdownMenuButton" style="position:relative">
                                                        <b-button class="dropdown-item text-green" @click="setId(reg.id)" v-b-modal.approve>Approve</b-button>
                                                        <b-button class="dropdown-item text-green" @click="setId(reg.id)" v-b-modal.disapprove>Disapprove</b-button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>	
                    </div>
                </div>                        
        </div>

        <confirm :modalId="'approve'" :modalTitle="'Approve Loan Request'">
            <div class="alert alert-info">
                Are you sure you want to confirm this approval?
                <span class="btn btn-primary" v-if="processing">...</span>
                <button v-else class="btn btn-primary" @click="approve()">Approve</button>
            </div>
        </confirm>

        <confirm :modalId="'disapprove'" :modalTitle="'Dispprove Loan Request'">
            <div class="alert alert-info">
                Are you sure you want to confirm this disapproval?
                <span class="btn btn-primary btn-disabled" v-if="processing">...</span>
                <button v-else class="btn btn-primary" @click="disapprove()">Disapprove</button>
            </div>
        </confirm>
    </div>
</template>
<script>
import {mapActions,mapState,mapGetters} from 'vuex'
import Confirm from '@/components/Confirm'
export default {
    components:{
        Confirm
    },

    data(){
        return{
            loanId:null
        }
    },
    
    computed:{
        ...mapState({
            loading:state=>state.loading,
            processing:state=>state.processing
        }),

        ...mapGetters('adminStore',['pendingLoanRequestApprovals'])
    },

    created(){
        if(this.pendingLoanRequestApprovals.length == 0){
            this.getPendingLoanRequestApprovals()
        }
    },

    methods:{
        ...mapActions('adminStore',['getPendingLoanRequestApprovals','approveLoanRequest','disapproveLoanRequest']),

        setId(id){
            this.loanId = id
        },

        approve(){
            this.approveLoanRequest({id:this.loanId,cb:()=>{
                this.$bvModal.hide('approve')
            }})
        },

        disapprove(){
            this.disapproveLoanRequest({id:this.loanId,cb:()=>{
                this.$bvModal.hide('disapprove')
            }})
        }
    }
}
</script>